"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const products = e.data;
    if (!products)
        return;
    if (typeof window.adobeDataLayer === 'undefined')
        return;
    window.adobeDataLayer.push({
        component: {
            signup: null,
        },
    });
    const analyticsEvent = {};
    analyticsEvent.event = 'ul:brandOptOut';
    analyticsEvent.component = {
        signup: {
            brandOptOut: e.data.brandOptOut,
        },
    };
    window.adobeDataLayer.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
